<template>
  <div
    ref="dropMenu"
    class="drop-down-component"
  >
    <!-- 按钮 -->
    <span
      ref="dropButton"
      :class="[btnClass? btnClass:'lv-bn lv-ba lv-bh drop-down-button']"
      @click="dropDown"
    >
      <slot name="btname">{{ name }}</slot>
      <!-- 弹出列表 -->
      <div
        v-if="isShowMenu"
        ref="dropList"
        class="drop-down-list clearfix"
        :style="{width:`${menuWidth}px`}"
      >
        <slot name="drop-down-slot-ul">
          <ul class="menu">
            <li
              v-for="(val,index) in curList"
              :key="val.key"
              class="dorp-down-list-li"
              @click="theEvent(val)"
            >
              <slot
                name="menu-item"
                :data="{data:val,index:index}"
              ><span>{{ $t(val.name) }}</span></slot>
            </li>
          </ul>
        </slot>
      </div>
    </span>
  </div>
</template>
<script>
import { getWidthOrHeight } from 'js/util/util.js'

export default {
  props: {
    // 按钮的名字
    name: {
      type: String,
      default: '',
    },
    // 展开下拉菜单之前
    beforeDropDown: {
      type: Function,
      default: null,
    },
    // 自定义加载下拉方法
    appendList: {
      type: Function,
      default: null,
    },
    // 列表
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // btn样式
    btnClass: {
      type: String,
      default: '',
    },
    menuWidth: {
      type: [String, Number],
      default: '160',
    },
  },
  data() {
    return {
      isShowMenu: false,
      curList: [],
    }
  },
  watch: {
    /**
             * 当下拉菜单展开时注册全局的click事件
             * 当下拉菜单收起时取消全局的click事件
             */
    isShowMenu(n) {
      const iframe = document.getElementById('pdfframe')
      if (n) {
        document.addEventListener('click', this.otherClick)
        // 可传一个函数来注册iframe的点击事件
        // 目前预览页面会有一个iframe所以加到组件里
        iframe && iframe.contentDocument && iframe.contentDocument.addEventListener('click', this.otherClick)
        return
      }
      document.removeEventListener('click', this.otherClick)
      iframe && iframe.contentDocument && iframe.contentDocument.removeEventListener('click', this.otherClick)
    },
  },
  created() {
    this.curList = this.list
  },
  methods: {
    /**
             * 点击空白区域
             */
    otherClick() {
      this.isShowMenu = false
    },
    /**
             * 展开下拉菜单
             * 控制菜单的显示隐藏
             */
    dropDown(e) { // 点击列表事件
      if (Array.from(e.target.classList).includes('btn-share')) { // pcs-9296 临时处理，二期增加查看历史链接
        this.theEvent(this.list[0])
        return
      }
      if (this.beforeDropDown && this.beforeDropDown instanceof Function) {
        this.beforeDropDown(this.list)
        return
      }
      if (this.appendList && this.appendList instanceof Function) {
        this.curList = this.appendList()
      }
      this.isShowMenu = !this.isShowMenu // toggle
      if (this.isShowMenu) {
        this.locateMen(e)
      }
    },
    /**
             * 定位下拉框位置
             */
    locateMen(e) { // 蒙板
      this.$nextTick(function () {
        const le = 4
        const btn = this.$refs.dropButton
        const rect = btn.getBoundingClientRect()
        // 获取菜单的宽度
        const menu = this.$refs.dropList
        const menuW = getWidthOrHeight(menu, 'width')
        const menuH = getWidthOrHeight(menu, 'height')
        // 获取浏览器的宽度
        const winWith = window.innerWidth
        const rWith = winWith - rect.right - le
        // 获取浏览器的高度
        const winHeight = window.document.documentElement.clientHeight
        // 距下距上
        const tHeight = rect.top + le
        const bHeight = winHeight - rect.bottom - le
        // 距上距下的高度全小于当前文件菜单高度的时候
        if (tHeight < menuH && bHeight < menuH) {
          if (rect.bottom > menuH) {
            // menu.style.bottom = `${winHeight - rect.bottom + le}px` //加动效算法
            menu.style.bottom = '0px'
          } else {
            menu.style.top = '0px'
          }
          // 此时重新算左右
          if (rWith < menuW) {
            menu.style.right = `${rect.width + le}px`
          } else {
            menu.style.left = `${rect.width + le}px`
          }
          return
        }
        if ((winWith - rect.right) < menuW) {
          menu.style.right = '0px'
        } else {
          menu.style.left = '0px'
        }
        if (bHeight < menuH) {
          // 朝上
          menu.style.bottom = `${rect.height + le}px`
        } else {
          // 朝下
          menu.style.top = `${rect.height + le}px`
        }
      })
    },
    /**
             * 点击当前菜单
             */
    theEvent(val) {
      this.$emit('click-item', val)
      this.isShowMenu = false
    },
  },
}
</script>
<style lang="less">
@import '~less/button.less';
.head{
  display: inline-block;
  cursor: pointer;
  text-align: center;
  width: 30px;
  height: 30px;
  background-color: #F7B500 ;
  line-height: 30px;
  border-radius: 50%;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
}
.drop-down-component {
  display: inline-block;
  position: relative;
}
.scroll{   //滚动条
  overflow-x: hidden;
  overflow-y: auto;
}
.drop-down-button {    //按钮
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
  display: block;
  margin: auto;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #C1C7CD;
  font-size: 14px;
  color: #1B2733;
  background: #FFFFFF;
  user-select: none;    //无法选中文字部分
  position: relative;
}

.drop-down-list {     //弹出列表
  padding:8px 0px;
  z-index: 1;
  box-shadow: 0 4px 14px 0 rgba(5, 15, 40, .1);
  background: #fff;
  border-radius: 2px;
  border: 1px solid #e8ebef;
  width: 160px;
  position:absolute;
  overflow: hidden;
  text-align: left;
}
.drop-down-list-ul::-webkit-scrollbar {  //滚动条样式
  width: 4px;
}

.drop-down-list-ul::-webkit-scrollbar-thumb {
  background: rgb(194, 199, 205);
  border-radius: 5px;
}
.dorp-down-list-li {
  line-height: 36px;
  padding: 0 16px;
  color: #282e3d;
}

.dorp-down-list-li:hover {   //li hover
  background-color: rgb(246, 247, 250);
}
</style>
